import React from 'react';
import { PHOTOS } from '../data/sectionsData';
import ShowMoreButton from './ShowMoreButton';

const INITIAL_VISIBLE_PHOTOS = 8;

export default function PhotographySection({ expanded, onToggle, getVisibleItems, onOpenLightbox }) {
    return (
        <section className="bg-gradient-to-b from-[#0f0f1a] via-[#141425] to-[#1a1a2e] py-16 md:py-24 px-4 md:px-6 relative overflow-hidden" id="photography">
            {/* Ambient glow */}
            <div className="absolute inset-0 z-0 overflow-hidden">
                <div className="absolute w-[500px] h-[500px] rounded-full bg-[#6750a4]/10 top-[20%] -left-[200px] blur-[120px]" />
                <div className="absolute w-[400px] h-[400px] rounded-full bg-[#00bcd4]/10 bottom-[10%] -right-[150px] blur-[120px]" />
            </div>

            <div className="max-w-[1200px] mx-auto relative z-10">
                <div className="mb-16 reveal">
                    <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-[#00bcd4]/15 text-[#00bcd4] rounded-full text-[0.8125rem] font-semibold uppercase tracking-widest mb-4">
                        <i className="fa-solid fa-camera-retro"></i> Photography
                    </span>
                    <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-bold tracking-tight text-[#f5f5f5] mb-2">Through My Lens</h2>
                    <p className="text-[1.0625rem] text-[#f5f5f5]/60 max-w-[560px] leading-relaxed">
                        The buildings, landscapes, scenary, and everything that I've captured on my journeys.
                    </p>
                </div>

                {/* Masonry-style photo grid */}
                <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4 auto-rows-[180px] md:auto-rows-[200px]">
                    {getVisibleItems('photos', PHOTOS).map((photo, i) => (
                        <div
                            key={i}
                            className={`group relative rounded-2xl overflow-hidden cursor-pointer ${photo.span} hover:shadow-[0_8px_40px_rgba(0,188,212,0.15)] transition-all duration-400 ease-emphasized reveal reveal-delay-${Math.min(i + 1, 4)}`}
                            onClick={() => onOpenLightbox({ type: 'photo', title: photo.title, subtitle: photo.location, extra: photo.camera, imageLink: photo.imageLink, locationLink: photo.locationLink })}
                        >
                            {/* Photo image */}
                            <img
                                src={photo.imageLink}
                                alt={photo.title}
                                className="w-full h-full object-cover group-hover:scale-[1.08] transition-transform duration-600 ease-standard"
                                loading="lazy"
                            />

                            {/* Hover overlay */}
                            <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent flex flex-col justify-end p-4 md:p-5 opacity-0 group-hover:opacity-100 transition-opacity duration-300 ease-standard">
                                <h4 className="text-white font-semibold text-sm md:text-base leading-tight mb-1">{photo.title}</h4>
                                <p className="text-white/70 text-xs flex items-center gap-1.5">
                                    <i className="fa-solid fa-location-dot"></i> {photo.location}
                                </p>
                                <p className="text-white/50 text-xs flex items-center gap-1.5 mt-0.5">
                                    <i className="fa-solid fa-camera"></i> {photo.camera}
                                </p>
                            </div>
                        </div>
                    ))}
                </div>
                <ShowMoreButton
                    expanded={expanded}
                    onClick={onToggle}
                    totalCount={PHOTOS.length}
                    visibleCount={INITIAL_VISIBLE_PHOTOS}
                    variant="photo"
                />
            </div>
        </section>
    );
}
